module.exports = "/images/logo-dotloop-icon.png?8917201434c10e7c6bb65c2b03420207";